import RetsListing from '@bb/domain/dist/types/RetsListing';
import React, { useState, useEffect } from 'react';
import { getAllBoards } from '../../../../../api/RetsController';

type AllBoardsType = Awaited<ReturnType<typeof getAllBoards>>;

type TriggerRetsUpdatePageContextType = {
  boards: AllBoardsType;
  setBoards: React.Dispatch<React.SetStateAction<AllBoardsType>>;
  retsListing?: RetsListing;
  setRetsListing: React.Dispatch<React.SetStateAction<RetsListing>>;
  retsListingId: string;
  setRetsListingId: React.Dispatch<React.SetStateAction<string>>;
  retsListingMlsNumber: string;
  setRetsListingMlsNumber: React.Dispatch<React.SetStateAction<string>>;
  retsListingBoardId: string;
  setRetsListingBoardId: React.Dispatch<React.SetStateAction<string>>;
  shouldCreateCopy: boolean;
  setShouldCreateCopy: React.Dispatch<React.SetStateAction<boolean>>;
  updates: Record<string, any>;
  setUpdates: React.Dispatch<React.SetStateAction<Record<string, any>>>;
};

const TriggerRetsListingUpdatePageContext =
  React.createContext<TriggerRetsUpdatePageContextType>(
    {} as TriggerRetsUpdatePageContextType,
  );

export const TriggerRetsListingUpdatePageProvider: React.FC = ({
  children,
}) => {
  const [boards, setBoards] = useState<
    TriggerRetsUpdatePageContextType['boards']
  >([]);
  const [retsListing, setRetsListing] =
    useState<TriggerRetsUpdatePageContextType['retsListing']>();
  const [retsListingId, setRetsListingId] = useState('');
  const [retsListingMlsNumber, setRetsListingMlsNumber] = useState('');
  const [retsListingBoardId, setRetsListingBoardId] = useState('');
  const [shouldCreateCopy, setShouldCreateCopy] = useState(false);
  const [updates, setUpdates] = useState<
    TriggerRetsUpdatePageContextType['updates']
  >({});

  useEffect(() => {
    const fetchBoards = async () => {
      const res = await getAllBoards();
      setBoards(res);
    };
    fetchBoards();
  }, []);

  return (
    <TriggerRetsListingUpdatePageContext.Provider
      value={{
        boards,
        setBoards,
        retsListing,
        setRetsListing,
        retsListingId,
        setRetsListingId,
        retsListingMlsNumber,
        setRetsListingMlsNumber,
        retsListingBoardId,
        setRetsListingBoardId,
        shouldCreateCopy,
        setShouldCreateCopy,
        updates,
        setUpdates,
      }}
    >
      {children}
    </TriggerRetsListingUpdatePageContext.Provider>
  );
};

export default TriggerRetsListingUpdatePageContext;
